export default __webpack_public_path__ + "static/media/a8.c1db7521.png";